import {Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DxTabsModule} from 'devextreme-angular';
import {AccessType, AuthService, PermissionType} from '@services';
import {OrdersHeaderComponent} from './orders-header/orders-header.component';
import {OrderLinesComponent} from './order-lines/order-lines.component';
import {LoadLevelComponent} from './load-level/load-level.component';

@Component({
    selector: 'app-orders',
    standalone: true,
    imports: [
        DxTabsModule,
        OrdersHeaderComponent,
        OrderLinesComponent,
        LoadLevelComponent
    ],
    templateUrl: './orders.component.html'
})
export class OrdersComponent {
    private route = inject(ActivatedRoute);
    private router = inject(Router);
    private authService = inject(AuthService);

    private readonly defaultTab = 'header';

    private readonly canViewInternalTabs = this.authService.checkPermission(PermissionType.Orders, AccessType.Edit);

    tabs = [
        {text: 'Header Level', id: 'header'},
        ...(this.canViewInternalTabs ? [
            {text: 'Line Level', id: 'line'},
            {text: 'Load Level', id: 'load'}
        ] : [])
    ];

    selectedTabKeys: string[] = [this.defaultTab];

    constructor() {
        this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
            const tabParam = params['tab'];
            const validTab = this.tabs.find(t => t.id === tabParam);
            this.selectedTabKeys = [validTab?.id ?? this.defaultTab];
        });
    }

    async onTabClick(id: string) {
        await this.router.navigate(['/outbound/orders', id]);
    }
}
